import { Component } from '@angular/core';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';
import { RouterLinkActive, RouterLink, RouterOutlet } from '@angular/router';
import { PageTabsComponent } from '@next/core-lib/components';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
  selector: 'insemination-advice',
  templateUrl: './insemination-advice.component.html',
  styleUrls: ['./insemination-advice.component.scss'],
  imports: [
    PageTabsComponent,
    MatTabNav,
    MatTabLink,
    RouterLinkActive,
    RouterLink,
    MatTabNavPanel,
    RouterOutlet,
    TranslatePipe,
  ],
})
export class InseminationAdviceComponent {}
